import { useState } from "react";
import GroupPicker from "./GroupPicker";
import { FaCog } from "react-icons/fa";
import GroupSettings from "./GroupSettings";
import StudentItem from "../StudentItem";
import { useGroupManager } from "../../../hooks/useGroupManager";

export default function GroupSection() {
  const {
    groups,
    setGroups,
    selectedGroup,
    setSelectedGroup,
    setStudentNoGroup,
    selectedStudentInGroup,
    setSelectedStudentInGroup,
    sortedStudentsWithGroup,
    sortedGroups,
  } = useGroupManager();
  const [toggleSetting, SetToggleSetting] = useState(false);

  function handleToggleSettings() {
    SetToggleSetting(!toggleSetting);
  }

  return (
    <section className="lg:w-[25vw] sm:w-[30vw] max-sm:min-w-full h-[60vh] border border-black overflow-y-scroll bg-primary-blue ">
      <div className="flex px-1 items-center">
        <GroupPicker
          groups={sortedGroups}
          setSelectedGroup={setSelectedGroup}
        />
        <button
          className={`${
            toggleSetting
              ? "bg-secondary-yellow text-white"
              : "bg-tertiary-yellow"
          } h-6 w-6 flex items-center justify-center`}
          onClick={handleToggleSettings}
          aria-label="option de groupe"
        >
          <FaCog />
        </button>
      </div>
      {toggleSetting && (
        <GroupSettings
          groups={sortedGroups}
          setGroups={setGroups}
          setStudentNoGroup={setStudentNoGroup}
        />
      )}

      {groups &&
        selectedGroup &&
        !toggleSetting &&
        sortedStudentsWithGroup.map((student) => (
          <StudentItem
            studentName={`${student.surname} ${student.name}`}
            studentId={student.id}
            setSelectedStudent={setSelectedStudentInGroup}
            selectedStudent={selectedStudentInGroup}
            key={student.id}
            purpose={"remove"}
          />
        ))}
    </section>
  );
}
